import React from 'react';
import {SCHEDULE_FIELD_HEIGHT, SCHEDULE_FIELD_UNIT_WIDTH} from "../../constants/cssConstants";
import Unit from "./Unit";

class Units extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: props.isLoading
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.isLoading !== this.props.isLoading) {
            this.setState({isLoading: this.props.isLoading});
        }
    }

    render() {
        const units = [];
        if(!this.state.isLoading && this.props.plan) {
            const planTotalUnit = this.props.getUnits.getPlanTotalUnit(this.props.plan._id);
            for(let i = 0; i < 4; i++) {
                const yearTotalUnit = this.props.getUnits.getYearTotalUnit(this.props.plan._id, i);
                units.push(<div>
                    {
                        i !== 3
                            ? <div style={{marginTop: 50, marginBottom: 50}}>
                                <Unit name={"Year " + (i+1)} unit={yearTotalUnit} isLoading={this.props.isLoading} />
                            </div>
                            : <div style={{marginTop: 50}}>
                                <Unit name={"Year " + (i+1)} unit={yearTotalUnit} isLoading={this.props.isLoading} />
                                <Unit name={"Cumulative"} unit={planTotalUnit} isLoading={this.props.isLoading} />
                            </div>
                    }
                </div>)
            }
        } else {
            for(let i = 0; i < 4; i++) {
                units.push(<div>
                    {
                        i !== 3
                            ? <div style={{marginTop: 50, marginBottom: 50}}>
                                <Unit name={"Year " + (i+1)} unit={0} isLoading={this.props.isLoading} />
                            </div>
                            : <div style={{marginTop: 50}}>
                                <Unit name={"Year " + (i+1)} unit={0} isLoading={this.props.isLoading} />
                                <Unit name={"Cumulative"} unit={0} isLoading={this.props.isLoading} />
                            </div>
                    }
                </div>)
            }
        }
        return(
            <div style={{height: SCHEDULE_FIELD_HEIGHT - 20, width: SCHEDULE_FIELD_UNIT_WIDTH, marginTop: 20,
                display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                { units }
            </div>
        );
    }
}

export default Units;